import { Deselect, KeyboardArrowUp, SelectAll } from '@mui/icons-material';
import AbcOutlinedIcon from '@mui/icons-material/AbcOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccessTimeFilledOutlinedIcon from '@mui/icons-material/AccessTimeFilledOutlined';
import AccountTree from '@mui/icons-material/AccountTree';
import Add from '@mui/icons-material/Add';
import AddBox from '@mui/icons-material/AddBoxTwoTone';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import Api from '@mui/icons-material/Api';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AutoFixHigh from '@mui/icons-material/AutoFixHigh';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import BarChartIcon from '@mui/icons-material/BarChart';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CallMergeIcon from '@mui/icons-material/CallMerge';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Close from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CodeIcon from '@mui/icons-material/Code';
import CompressIcon from '@mui/icons-material/Compress';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import CropFreeIcon from '@mui/icons-material/CropFree';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DataArrayIcon from '@mui/icons-material/DataArray';
import DataObjectOutlinedIcon from '@mui/icons-material/DataObjectOutlined';
import Delete from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EditIcon from '@mui/icons-material/Edit';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import EventIcon from '@mui/icons-material/Event';
import EventRepeat from '@mui/icons-material/EventRepeat';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import Fullscreen from '@mui/icons-material/Fullscreen';
import FullscreenExit from '@mui/icons-material/FullscreenExit';
import GetAppIcon from '@mui/icons-material/GetApp';
import GoogleIcon from '@mui/icons-material/Google';
import GroupIcon from '@mui/icons-material/Group';
import Groups from '@mui/icons-material/Groups';
import Home from '@mui/icons-material/Home';
import HttpsIcon from '@mui/icons-material/Https';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import KeyIcon from '@mui/icons-material/Key';
import { default as KeyboardArrowDownIcon } from '@mui/icons-material/KeyboardArrowDown';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import LayersIcon from '@mui/icons-material/Layers';
import LinkIcon from '@mui/icons-material/Link';
import List from '@mui/icons-material/List';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import LoopIcon from '@mui/icons-material/Loop';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { default as Menu, default as MenuIcon } from '@mui/icons-material/Menu';
import MergeIcon from '@mui/icons-material/Merge';
import MultipleStopIcon from '@mui/icons-material/MultipleStop';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Notifications from '@mui/icons-material/Notifications';
import OpenInNew from '@mui/icons-material/OpenInNew';
import OpenWith from '@mui/icons-material/OpenWith';
import Person from '@mui/icons-material/Person';
import PhishingIcon from '@mui/icons-material/Phishing';
import PinOutlinedIcon from '@mui/icons-material/PinOutlined';
import PlayArrow from '@mui/icons-material/PlayArrow';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import QuestionMark from '@mui/icons-material/QuestionMark';
import Refresh from '@mui/icons-material/Refresh';
import RemoveIcon from '@mui/icons-material/Remove';
import RuleIcon from '@mui/icons-material/Rule';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import Save from '@mui/icons-material/Save';
import SearchIcon from '@mui/icons-material/Search';
import SendIcon from '@mui/icons-material/Send';
import Settings from '@mui/icons-material/Settings';
import SettingsApplications from '@mui/icons-material/SettingsApplications';
import SkipNext from '@mui/icons-material/SkipNext';
import SkipPrevious from '@mui/icons-material/SkipPrevious';
import SortIcon from '@mui/icons-material/Sort';
import SpeedIcon from '@mui/icons-material/Speed';
import StopIcon from '@mui/icons-material/Stop';
import StorageIcon from '@mui/icons-material/Storage';
import SyncIcon from '@mui/icons-material/Sync';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import VpnLockIcon from '@mui/icons-material/VpnLock';
import WarningIcon from '@mui/icons-material/Warning';
import xero from '../../../../assets/icons/Xero_software_logo.svg';
import amazonS3 from '../../../../assets/icons/amazon-s3.svg';
import aws from '../../../../assets/icons/aws-svgrepo-com.svg';
import hubSpot from '../../../../assets/icons/hubspot-icon.svg';
import methodData from '../../../../assets/icons/md-icon_white.svg';
import salesForce from '../../../../assets/icons/salesforce-icon.svg';
import shopify from '../../../../assets/icons/shopify-icon.svg';
import ImageRender from '../image-render/image-render';
import IconLoaderProperties from './icon-loader-properties';
import IconSelector from './icon-selector';

//Add icons as needed. DO NOT import   * from '@mui/icons-material' since it will include 6.5Mb of icons in the bundle
//Icon list can be found here https://mui.com/material-ui/material-icons/
export default function IconLoader({ id, icon, sx }: IconLoaderProperties) {
	const iconSelector = (icon: IconSelector) => {
		switch (icon) {
			case IconSelector.Home:
				return <Home id={id} key={id} sx={sx} />;
			case IconSelector.Assignment:
				return <AssignmentIcon id={id} key={id} sx={sx} />;
			case IconSelector.BarChart:
				return <BarChartIcon id={id} key={id} sx={sx} />;
			case IconSelector.Dashboard:
				return <DashboardIcon id={id} key={id} sx={sx} />;
			case IconSelector.OpenWith:
				return <OpenWith id={id} key={id} sx={sx} />;
			case IconSelector.OpenInNew:
				return <OpenInNew id={id} key={id} sx={sx} />;
			case IconSelector.AccountTree:
				return <AccountTree id={id} key={id} sx={sx} />;
			case IconSelector.Person:
				return <Person id={id} key={id} sx={sx} />;
			case IconSelector.Groups:
				return <Groups id={id} key={id} sx={sx} />;
			case IconSelector.EventRepeat:
				return <EventRepeat id={id} key={id} sx={sx} />;
			case IconSelector.SettingsApplications:
				return <SettingsApplications id={id} key={id} sx={sx} />;
			case IconSelector.Settings:
				return <Settings id={id} key={id} sx={sx} />;
			case IconSelector.Api:
				return <Api id={id} key={id} sx={sx} />;
			case IconSelector.CropFree:
				return <CropFreeIcon id={id} key={id} sx={sx} />;
			case IconSelector.ChevronRight:
				return <ChevronRightIcon id={id} key={id} sx={sx} />;
			case IconSelector.Delete:
				return <Delete id={id} key={id} sx={sx} />;
			case IconSelector.Add:
				return <Add id={id} key={id} sx={sx} />;
			case IconSelector.AddBox:
				return <AddBox id={id} key={id} sx={sx} />;
			case IconSelector.Close:
				return <Close id={id} key={id} sx={sx} />;
			case IconSelector.CancelIcon:
				return <CancelIcon id={id} key={id} sx={sx} />;
			case IconSelector.Menu:
				return <Menu id={id} key={id} sx={sx} />;
			case IconSelector.Notifications:
				return <Notifications id={id} key={id} sx={sx} />;
			case IconSelector.ChevronLeft:
				return <ChevronLeftIcon id={id} key={id} sx={sx} />;
			case IconSelector.KeyboardDoubleArrowLeft:
				return <KeyboardDoubleArrowLeftIcon id={id} key={id} sx={sx} />;
			case IconSelector.KeyboardDoubleArrowRight:
				return <KeyboardDoubleArrowRightIcon id={id} key={id} sx={sx} />;
			case IconSelector.KeyboardArrowUp:
				return <KeyboardArrowUp id={id} key={id} sx={sx} />;
			case IconSelector.KeyboardDoubleArrowUp:
				return <KeyboardDoubleArrowUpIcon id={id} key={id} sx={sx} />;
			case IconSelector.KeyboardDoubleArrowDown:
				return <KeyboardDoubleArrowDownIcon id={id} key={id} sx={sx} />;
			case IconSelector.KeyboardArrowDown:
				return <KeyboardArrowDownIcon id={id} key={id} sx={sx} />;
			case IconSelector.KeyboardArrowRight:
				return <KeyboardArrowRightIcon id={id} key={id} sx={sx} />;
			case IconSelector.ErrorOutlined:
				return <ErrorOutlinedIcon id={id} key={id} sx={sx} />;
			case IconSelector.ErrorOutlineOutlined:
				return <ErrorOutlineOutlinedIcon id={id} key={id} sx={sx} />;
			case IconSelector.CheckCircle:
				return <CheckCircleIcon id={id} key={id} sx={sx} />;
			case IconSelector.Search:
				return <SearchIcon id={id} key={id} sx={sx} />;
			case IconSelector.AccessTimeFilledOutlined:
				return <AccessTimeFilledOutlinedIcon id={id} key={id} sx={sx} />;
			case IconSelector.ExpandMore:
				return <ExpandMoreIcon id={id} key={id} sx={sx} />;
			case IconSelector.FormatListBulletedOutlined:
				return <FormatListBulletedOutlinedIcon id={id} key={id} sx={sx} />;
			case IconSelector.RuleOutlinedIcon:
				return <RuleOutlinedIcon id={id} key={id} sx={sx} />;
			case IconSelector.AbcOutlinedIcon:
				return <AbcOutlinedIcon id={id} key={id} sx={sx} />;
			case IconSelector.DataObjectOutlinedIcon:
				return <DataObjectOutlinedIcon id={id} key={id} sx={sx} />;
			case IconSelector.PinOutlinedIcon:
				return <PinOutlinedIcon id={id} key={id} sx={sx} />;
			case IconSelector.List:
				return <List id={id} key={id} sx={sx} />;
			case IconSelector.Fullscreen:
				return <Fullscreen id={id} key={id} sx={sx} />;
			case IconSelector.FullscreenExit:
				return <FullscreenExit id={id} key={id} sx={sx} />;
			case IconSelector.ArrowDropDownIcon:
				return <ArrowDropDownIcon id={id} key={id} sx={sx} />;
			case IconSelector.ArrowRightIcon:
				return <ArrowRightIcon id={id} key={id} sx={sx} />;
			case IconSelector.Refresh:
				return <Refresh id={id} key={id} sx={sx} />;
			case IconSelector.Save:
				return <Save id={id} key={id} sx={sx} />;
			case IconSelector.AddToPhotos:
				return <AddToPhotosIcon id={id} key={id} sx={sx} />;
			case IconSelector.Sync:
				return <SyncIcon id={id} key={id} sx={sx} />;
			case IconSelector.CheckCircleOutline:
				return <CheckCircleOutlineIcon id={id} key={id} sx={sx} />;
			case IconSelector.InfoIcon:
				return <InfoIcon id={id} key={id} sx={sx} />;
			case IconSelector.MergeIcon:
				return <MergeIcon id={id} key={id} sx={sx} />;
			case IconSelector.ContentCopyIcon:
				return <ContentCopyIcon id={id} key={id} sx={sx} />;
			case IconSelector.Warning:
				return <WarningIcon id={id} key={id} sx={sx} />;
			case IconSelector.PlayArrow:
				return <PlayArrow id={id} key={id} sx={sx} />;
			case IconSelector.Visibility:
				return <Visibility id={id} key={id} sx={sx} />;
			case IconSelector.VisibilityOff:
				return <VisibilityOff id={id} key={id} sx={sx} />;
			case IconSelector.ManageAccountsIcon:
				return <ManageAccountsIcon id={id} key={id} sx={sx} />;
			case IconSelector.Edit:
				return <EditIcon id={id} key={id} sx={sx} />;
			case IconSelector.Group:
				return <GroupIcon id={id} key={id} sx={sx} />;
			case IconSelector.Key:
				return <KeyIcon id={id} key={id} sx={sx} />;
			case IconSelector.Google:
				return <GoogleIcon id={id} key={id} sx={sx} />;
			case IconSelector.SkipPrevious:
				return <SkipPrevious id={id} key={id} sx={sx} />;
			case IconSelector.SkipNext:
				return <SkipNext id={id} key={id} sx={sx} />;
			case IconSelector.DataArray:
				return <DataArrayIcon id={id} key={id} sx={sx} />;
			case IconSelector.Event:
				return <EventIcon id={id} key={id} sx={sx} />;
			case IconSelector.Lock:
				return <HttpsIcon id={id} key={id} sx={sx} />;
			case IconSelector.Upload:
				return <CloudUploadIcon id={id} key={id} sx={sx} />;
			case IconSelector.AutoFixHigh:
				return <AutoFixHigh id={id} key={id} sx={sx} />;
			case IconSelector.NavigateNextIcon:
				return <NavigateNextIcon id={id} key={id} sx={sx} />;
			case IconSelector.NavigateBeforeIcon:
				return <NavigateBeforeIcon id={id} key={id} sx={sx} />;
			case IconSelector.DoneIcon:
				return <DoneIcon id={id} key={id} sx={sx} />;
			case IconSelector.RemoveIcon:
				return <RemoveIcon id={id} key={id} sx={sx} />;
			case IconSelector.VpnLock:
				return <VpnLockIcon id={id} key={id} sx={sx} />;
			case IconSelector.AutoGraphIcon:
				return <AutoGraphIcon id={id} key={id} sx={sx} />;
			case IconSelector.MenuIcon:
				return <MenuIcon id={id} key={id} sx={sx} />;
			case IconSelector.DragIndicatorIcon:
				return <DragIndicatorIcon id={id} key={id} sx={sx} />;
			case IconSelector.ChevronUp:
				return <ExpandLessIcon id={id} key={id} sx={sx} />;
			case IconSelector.ChevronDown:
				return <ExpandMoreIcon id={id} key={id} sx={sx} />;
			case IconSelector.PhishingIcon:
				return <PhishingIcon id={id} key={id} sx={sx} />;
			case IconSelector.FileUploadIcon:
				return <FileUploadIcon id={id} key={id} sx={sx} />;
			case IconSelector.GetAppIcon:
				return <GetAppIcon id={id} key={id} sx={sx} />;
			case IconSelector.RuleIcon:
				return <RuleIcon id={id} key={id} sx={sx} />;
			case IconSelector.AccessTimeIcon:
				return <AccessTimeIcon id={id} key={id} sx={sx} />;
			case IconSelector.StorageIcon:
				return <StorageIcon id={id} key={id} sx={sx} />;
			case IconSelector.CallSplitIcon:
				return <CallSplitIcon id={id} key={id} sx={sx} />;
			case IconSelector.CallMergeIcon:
				return <CallMergeIcon id={id} key={id} sx={sx} />;
			case IconSelector.CodeIcon:
				return <CodeIcon id={id} key={id} sx={sx} />;
			case IconSelector.CompressIcon:
				return <CompressIcon id={id} key={id} sx={sx} />;
			case IconSelector.InsertDriveFileIcon:
				return <InsertDriveFileIcon id={id} key={id} sx={sx} />;
			case IconSelector.LoopIcon:
				return <LoopIcon id={id} key={id} sx={sx} />;
			case IconSelector.LayersIcon:
				return <LayersIcon id={id} key={id} sx={sx} />;
			case IconSelector.Check:
				return <CheckIcon id={id} key={id} sx={sx} />;
			case IconSelector.ImportExportIcon:
				return <ImportExportIcon id={id} key={id} sx={sx} />;
			case IconSelector.s3Icon:
				return (
					<ImageRender
						src={amazonS3}
						sx={{
							display: 'inline-flex',
							mr: 1,
						}}
					/>
				);
			case IconSelector.MethodDataIcon:
				return (
					<ImageRender
						src={methodData}
						sx={{
							display: 'inline-flex',
							position: 'relative',
							height: 20,
							width: 20,
							top: 3,
							mr: 1,
						}}
					/>
				);
			case IconSelector.SalesForceIcon:
				return (
					<ImageRender
						src={salesForce}
						sx={{
							display: 'inline-flex',
							position: 'relative',
							height: 22,
							width: 22,
							top: 3,
							mr: 1,
							filter: 'invert(1) brightness(2)',
						}}
					/>
				);
			case IconSelector.HubSpotIcon:
				return (
					<ImageRender
						src={hubSpot}
						sx={{
							display: 'inline-flex',
							position: 'relative',
							height: 20,
							width: 20,
							top: 3,
							mr: 1,
							filter: 'invert(1) brightness(2)',
						}}
					/>
				);
			case IconSelector.ShopifyIcon:
				return (
					<ImageRender
						src={shopify}
						sx={{
							display: 'inline-flex',
							position: 'relative',
							height: 20,
							width: 20,
							top: 3,
							mr: 1,
							filter: 'invert(1) brightness(2)',
						}}
					/>
				);
			case IconSelector.AwsIcon:
				return (
					<ImageRender
						src={aws}
						sx={{
							display: 'inline-flex',
							position: 'relative',
							bottom: 2,
							mr: 1,
							height: 20,
							width: 20,
						}}
					/>
				);
			case IconSelector.XeroIcon:
				return (
					<ImageRender
						src={xero}
						sx={{
							display: 'inline-flex',
							position: 'relative',
							bottom: -2,
							mr: 1,
							height: 20,
							width: 20,
						}}
					/>
				);
			case IconSelector.LinkIcon:
				return <LinkIcon id={id} key={id} sx={sx} />;
			case IconSelector.StopIcon:
				return <StopIcon id={id} key={id} sx={sx} />;
			case IconSelector.TroubleshootIcon:
				return <TroubleshootIcon id={id} key={id} sx={sx} />;
			case IconSelector.CalendarMonthOutlinedIcon:
				return <CalendarMonthOutlinedIcon id={id} key={id} sx={sx} />;
			case IconSelector.LiveHelp:
				return <LiveHelpIcon id={id} key={id} sx={sx} />;
			case IconSelector.Send:
				return <SendIcon id={id} key={id} sx={sx} />;
			case IconSelector.DragHandle:
				return <DragHandleIcon id={id} key={id} sx={sx} />;
			case IconSelector.MultipleStopIcon:
				return <MultipleStopIcon id={id} key={id} sx={sx} />;
			case IconSelector.Sort:
				return <SortIcon id={id} key={id} sx={sx} />;
			case IconSelector.ContentPaste:
				return <ContentPasteGoIcon id={id} key={id} sx={sx} />;
			case IconSelector.PlaylistAdd:
				return <PlaylistAddIcon id={id} key={id} sx={sx} />;
			case IconSelector.Contacts:
				return <ConnectWithoutContactIcon id={id} key={id} sx={sx} />;
			case IconSelector.UpgradeIcon:
				return <UpgradeIcon id={id} key={id} sx={sx} />;
			case IconSelector.SelectAll:
				return <SelectAll id={id} key={id} sx={sx} />;
			case IconSelector.Test:
				return <SpeedIcon id={id} key={id} sx={sx} />;
			case IconSelector.Deselect:
				return <Deselect id={id} key={id} sx={sx} />;
			default:
				return <QuestionMark id={id} key={id} sx={sx} />;
		}
	};

	return iconSelector(icon);
}
